<div class="app-table">
    <div class="app-table-row">
        <div class="app-table-cell app-left-cell">
            <div class="v1-notes-cell">
                <div>
                    <p class="v1-notes-cell__title">Motivation</p>
                    <p class="v1-notes-cell__title">& Needs</p>
                    <div [@balloonEffect]="travelNeedsSaveStatus" class="saved-status">
                        <mat-icon class="material-icons">check_circle</mat-icon>
                        <span>Saved</span>
                    </div>
                </div>
                <mat-form-field>
                    <textarea matInput class="textarea-left" [formControl]="travelNeeds"
                        (focusout)="saveTravelNeeds()"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="app-table-cell app-right-cell">
            <div class="v1-notes-cell">
                <div class="indent">
                    <p class="v1-notes-cell__title">Other</p>
                    <div [@balloonEffect]=jobDesiresSaveStatus class="saved-status">
                        <mat-icon class="material-icons">check_circle</mat-icon>
                        <span>Saved</span>
                    </div>
                </div>
                <mat-form-field>
                    <textarea matInput [formControl]="jobDesires" (focusout)="saveJobDesires()"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>